import { Box, Breadcrumbs, Button, Link, TextField } from '@mui/material';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export default function AdminWrap({ children, title = '', toolbar }: AdminWrapProps) {
    const [breadcrumbs, setBreadcrumbs] = useState<AdminWrapBreadcrumb[]>([]);
    const [error, setError] = useState(false);
    const [pin, setPin] = useState('');
    const [admin, setAdmin] = useState(false);
    const router = useRouter();

    useEffect(() => {
        const pathSegments = router.asPath.split('/');
        const newBreadcrumbs = ['Admin', ...title.split('/')]
            .filter((label) => label)
            .map((label, index) => ({
                label,
                link: pathSegments.slice(0, index + 2).join('/'),
            }));
        setBreadcrumbs(newBreadcrumbs);
    }, [router.asPath, title]);

    function handleChange(e: any) {
        setError(false);
        setPin(e.target.value);
    }

    function handleSubmit(e: any) {
        e.preventDefault();
        setError(false);
        const isAdmin = !!process.env.NEXT_PUBLIC_ADMIN && pin === process.env.NEXT_PUBLIC_ADMIN;
        setAdmin(isAdmin);
        setPin(isAdmin ? pin : '');
        setError(!isAdmin);
    }

    return (
        <Box padding={5}>
            {admin ? (
                <>
                    <Box display="flex" gap={5} justifyContent="space-between" marginBottom={3}>
                        <Breadcrumbs>
                            {breadcrumbs.map((breadcrumb, index) => (
                                <Link
                                    color="inherit"
                                    component={NextLink}
                                    href={breadcrumb.link}
                                    key={index}
                                    underline="hover"
                                >
                                    {breadcrumb.label}
                                </Link>
                            ))}
                        </Breadcrumbs>
                        <Box>{toolbar}</Box>
                    </Box>
                    {children}
                </>
            ) : (
                <form onSubmit={handleSubmit}>
                    <Box alignItems="center" display="flex" gap={2} justifyContent="center">
                        <TextField error={error} label="Admin PIN" value={pin} onChange={handleChange} />
                        <Button disabled={!pin} type="submit">
                            Login
                        </Button>
                    </Box>
                </form>
            )}
        </Box>
    );
}
